import { PIMFormikSidebar } from './PIMFormikSidebar';

export default PIMFormikSidebar;
